import camel from "./camel";
import headline from "./headline";
import lcfirst from "./lcfirst";
import normalize from "./normalize";
import random from "./random";
import regex from "./regex";
import snake from "./snake";
import squish from "./squish";
import studly from "./studly";
import ucfirst from "./ucfirst";

export { camel, headline, lcfirst, normalize, random, regex, snake, squish, studly, ucfirst };

export default {
  camel,
  headline,
  lcfirst,
  normalize,
  random,
  regex,
  snake,
  squish,
  studly,
  ucfirst,
};
